import { Locale, K } from "../constants";

const locale: Locale = {
  [K.COPY_TOOLTIP]: "复制",
  [K.EXPORT_TOOLTIP]: "下载",
  [K.EXPAND]: "展开",
  [K.COLLAPSE]: "折叠",
  [K.COPY_SUCCESS]: "复制成功",
  [K.COPY_ERROR]: "复制失败",
};

export default locale;
